import { Link } from "react-router-dom"
import React from "react"

function Footer() {
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	return (
		<footer className="border-t-[20px] border-greenDark bg-white">
			<h3 className="h3 max-w-[590px] mx-auto pt-8">
				Folge uns auf Social Media <span className="hidden sm:inline">und werde Teil unserer Community</span>
			</h3>
			<div className="align-self-center mx-auto  pt-6 max-w-[220px] justify-center self-center text-center">
				<a
					href="https://www.instagram.com/bulldogskincare/"
					target="_blank"
					className="inline-block pr-8 md:max-w-[116px] lg:pt-0"
					rel="noreferrer"
					onClick={() => track("Instagram")}
					aria-label="Besuche uns auf Instagram"
				>
					<svg width="83" height="83" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M24.4815 0C10.9834 0 0 10.9834 0 24.4815V58.3759C0 71.874 10.9834 82.8574 24.4815 82.8574H58.3759C71.874 82.8574 82.8574 71.874 82.8574 58.3759V24.4815C82.8574 10.9834 71.874 0 58.3759 0H24.4815ZM24.4815 3.76715H58.3759C69.8364 3.76715 79.0902 13.021 79.0902 24.4815V58.3759C79.0902 69.8364 69.8364 79.0902 58.3759 79.0902H24.4815C13.021 79.0902 3.76715 69.8364 3.76715 58.3759V24.4815C3.76715 13.021 13.021 3.76715 24.4815 3.76715ZM64.0216 15.0686C61.9442 15.0686 60.2545 16.7484 60.2545 18.8357C60.2545 20.9131 61.9442 22.6029 64.0216 22.6029C66.109 22.6029 67.7888 20.9131 67.7888 18.8357C67.7888 16.7484 66.109 15.0686 64.0216 15.0686ZM41.4287 20.7143C30.008 20.7143 20.7143 30.008 20.7143 41.4287C20.7143 52.8494 30.008 62.143 41.4287 62.143C52.8494 62.143 62.143 52.8494 62.143 41.4287C62.143 30.008 52.8494 20.7143 41.4287 20.7143ZM41.4287 24.4815C50.8118 24.4815 58.3759 32.0456 58.3759 41.4287C58.3759 50.8118 50.8118 58.3759 41.4287 58.3759C32.0456 58.3759 24.4815 50.8118 24.4815 41.4287C24.4815 32.0456 32.0456 24.4815 41.4287 24.4815Z"
							fill="#046A38"
						/>
					</svg>
				</a>

				<a
					href="https://www.tiktok.com/@bulldogskincare"
					className="inline-block"
					target="_blank"
					rel="noreferrer"
					onClick={() => track("TikTok")}
					aria-label="Besuche uns auf TikTok"
				>
					<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.4129 0C4.23431 0 0 4.23431 0 9.4129V69.6674C0 74.846 4.23431 79.0803 9.4129 79.0803H69.6674C74.846 79.0803 79.0803 74.846 79.0803 69.6674V9.4129C79.0803 4.23431 74.846 0 69.6674 0H9.4129ZM9.4129 3.76715H69.6674C72.8183 3.76715 75.3131 6.26201 75.3131 9.4129V69.6674C75.3131 72.8183 72.8183 75.3131 69.6674 75.3131H9.4129C6.26201 75.3131 3.76715 72.8183 3.76715 69.6674V9.4129C3.76715 6.26201 6.26201 3.76715 9.4129 3.76715ZM41.5082 11.2915C40.4645 11.2915 39.6197 12.1364 39.6197 13.1701C39.6197 13.1701 39.5998 22.3544 39.5799 31.5586C39.57 36.1606 39.56 40.7627 39.5501 44.2317C39.5401 47.7006 39.5401 49.8874 39.5401 50.0762C39.5401 53.4955 36.439 56.2885 32.9004 56.2885C29.3917 56.2885 26.5887 53.4756 26.5887 49.9669C26.5887 46.4582 29.3917 43.6552 32.9004 43.6552C33.0197 43.6552 33.2583 43.6949 33.6658 43.7446C34.2025 43.8142 34.7393 43.6452 35.1369 43.2874C35.5444 42.9296 35.773 42.4127 35.773 41.876V33.964C35.773 32.97 34.9977 32.145 34.0137 32.0854C33.7155 32.0655 33.3477 32.0257 32.9004 32.0257C23.0104 32.0257 14.9593 40.0868 14.9593 49.9669C14.9593 59.8569 23.0104 67.9081 32.9004 67.9081C42.7805 67.9081 50.8416 59.8569 50.8416 49.9669V32.9302C53.575 35.1269 56.9943 36.5085 60.7614 36.5085C61.2783 36.5085 61.7653 36.4787 62.2325 36.439C63.1966 36.3495 63.9421 35.5344 63.9421 34.5604V25.7637C63.9421 24.7797 63.1768 23.9547 62.1927 23.8851C56.2687 23.4676 51.5572 18.8457 50.941 12.9813C50.8416 12.027 50.0265 11.2915 49.0624 11.2915H41.5082ZM43.3868 15.0587H47.6808C49.0425 21.271 53.903 26.0122 60.175 27.195V32.5923C56.1494 32.3836 52.6109 30.3757 50.5335 27.2149C50.0762 26.5191 49.2115 26.2011 48.4163 26.4396C47.6211 26.6782 47.0744 27.4137 47.0744 28.2486V49.9669C47.0744 57.8193 40.7428 64.1409 32.9004 64.1409C25.0481 64.1409 18.7264 57.8193 18.7264 49.9669C18.7264 42.4326 24.6008 36.4588 32.0058 35.9718V40.0769C26.8968 40.5441 22.8216 44.7386 22.8216 49.9669C22.8216 55.5132 27.3541 60.0458 32.9004 60.0458C38.417 60.0458 43.3073 55.712 43.3073 50.0762C43.3073 50.1657 43.3073 47.7006 43.3172 44.2317C43.3272 40.7727 43.3371 36.1606 43.347 31.5586C43.3669 23.2987 43.3769 16.6589 43.3868 15.0587Z"
							fill="#242424"
						/>
					</svg>
				</a>
			</div>
			<div className="mt-6  pb-6 text-center">
				<Link
					to={"/faq"}
					className="block sm:inline px-4 text-black font-CalibriRegular text-[18px]"
					onClick={() => track("FAQ")}
				>
					FAQs
				</Link>

				<Link
					to={"/teilnahmebedingungen"}
					className="block sm:inline px-4 text-black font-CalibriRegular text-[18px]"
					onClick={() => track("Teilnahmebedingungen")}
				>
					Teilnahmebedingungen
				</Link>

				<Link
					to={"/kontakt"}
					className="block sm:inline px-4 text-black font-CalibriRegular text-[18px]"
					onClick={() => track("Kontakt")}
				>
					Kontakt
				</Link>

			 
			</div>
		</footer>
	)
}

export default Footer
